'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Box, MediaQuery } from '@s7/base';
import { Typography } from '@s7/ui';
import { ActionLayout } from './layouts/ActionLayout/ActionLayout.js';
import { InfoLayout } from './layouts/InfoLayout/InfoLayout.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const FooterCallCenter = (props)=>{
    const { title, variant, primaryPhone, items, titleProps, onActionItemClick, onInfoItemClick, onPrimaryPhoneLinkClick, renderActionItem, renderPrimaryPhone, renderInfoItem } = props, others = _object_without_properties_loose(props, [
        "title",
        "variant",
        "primaryPhone",
        "items",
        "titleProps",
        "onActionItemClick",
        "onInfoItemClick",
        "onPrimaryPhoneLinkClick",
        "renderActionItem",
        "renderPrimaryPhone",
        "renderInfoItem"
    ]);
    const { actions, info } = items || {};
    const shouldRenderActions = variant === 'actions' && actions;
    const shouldRenderInfo = variant === 'info' && info;
    return /*#__PURE__*/ jsxs(Box, _extends({}, others, {
        children: [
            title && /*#__PURE__*/ jsx(MediaQuery, {
                query: "sm1.up",
                children: /*#__PURE__*/ jsx(Typography, _extends({
                    size: "lg1",
                    sx: {
                        marginBottom: 24
                    },
                    variant: "heading"
                }, titleProps, {
                    children: title
                }))
            }),
            shouldRenderActions && /*#__PURE__*/ jsx(ActionLayout, {
                items: actions,
                primaryPhone: primaryPhone,
                renderActionItem: renderActionItem,
                renderPrimaryPhone: renderPrimaryPhone,
                onActionItemClick: onActionItemClick,
                onPrimaryPhoneLinkClick: onPrimaryPhoneLinkClick
            }),
            shouldRenderInfo && /*#__PURE__*/ jsx(InfoLayout, {
                items: info,
                primaryPhone: primaryPhone,
                renderInfoItem: renderInfoItem,
                renderPrimaryPhone: renderPrimaryPhone,
                onInfoItemClick: onInfoItemClick,
                onPrimaryPhoneLinkClick: onPrimaryPhoneLinkClick
            })
        ]
    }));
};

export { FooterCallCenter };
//# sourceMappingURL=FooterCallCenter.js.map
